import { useMediaQuery, useTheme } from '@mui/material';

/**
 * Custom hook for responsive breakpoints
 * Returns booleans for isMobile, isTablet, and isDesktop
 */
export const useResponsive = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('md')); // < 768px
  const isTablet = useMediaQuery(theme.breakpoints.between('md', 'lg')); // 768px - 1023px
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg')); // >= 1024px

  // More specific breakpoints
  const isSmallMobile = useMediaQuery('(max-width:375px)'); // iPhone SE and smaller
  const isLargeMobile = useMediaQuery('(min-width:376px) and (max-width:767px)');

  return {
    isMobile,
    isTablet,
    isDesktop,
    isSmallMobile,
    isLargeMobile,
  };
};

export default useResponsive;
